import React from 'react';

import { KbjCard, KbjCardMeta, Piwik, SiteCoreDictionary } from '@eika-kortbetjening/types';
import { useViewType, ViewType } from '@eika/hooks';

import CardInfoWithImage from './card-info/CardInfoWithImage';
import { DigitalCardAndPin } from './digital-card-and-pin/DigitalCardAndPin';
import InfoLabels from './info-labels/InfoLabels';
import ReopenCardButton from './reopen-card-button/ReopenCardButton';

import './CardSimpleInfoAndFunctionality.scss';

interface CardSimpleInfoAndFunctionalityProps {
    card: KbjCard;
    cardMeta: KbjCardMeta;
    onDigitalCardClick: (() => void) | undefined;
    onSeePinClick: (() => void) | undefined;
    reopenCardClick: (() => void) | undefined;
    dictionary: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

export const CardSimpleInfoAndFunctionality = ({
    card,
    cardMeta,
    onDigitalCardClick,
    onSeePinClick,
    reopenCardClick,
    dictionary,
    piwik,
}: CardSimpleInfoAndFunctionalityProps) => {
    const viewType = useViewType();

    const isMobile = viewType !== ViewType.desktop;

    return (
        <div className="card-control-panel">
            <InfoLabels card={card} cardMeta={cardMeta} dictionary={dictionary} />
            <CardInfoWithImage card={card} />
            <DigitalCardAndPin
                onDigitalCardClick={onDigitalCardClick}
                onSeePinClick={onSeePinClick}
                piwik={piwik}
                isMobile={isMobile}
                dictionary={dictionary}
            />
            <ReopenCardButton
                cardMeta={cardMeta}
                reopenCardClick={reopenCardClick}
                isMobile={isMobile}
                dictionary={dictionary}
                piwik={piwik}
            />
        </div>
    );
};
